import { Link } from 'react-router-dom'

/**
 * Dashboard "complete your setup" card. Rendered when setup is derived-
 * incomplete — the tenant has no branches yet (the wizard creates the first
 * branch on its final step). Navigates to /setup/continue, which re-enters
 * the wizard at the right step for an already-authenticated owner.
 *
 * Setup completion is derived state, not a stored flag — see CLAUDE.md
 * "Tenant status transitions".
 */
export function SetupCompleteCTA() {
  return (
    <div className="owner-card owner-nudge" style={{ marginBottom: 14 }}>
      <div className="owner-nudge-body">
        <div className="owner-nudge-title">Finish setting up your account</div>
        <p className="owner-nudge-text">
          You're almost there — add your first branch to start issuing loyalty
          stamps.
        </p>
      </div>
      <Link to="/setup/continue" className="owner-btn owner-btn-primary owner-btn-sm">
        Complete setup
      </Link>
    </div>
  )
}
